"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.batchAffiliationErrorMessageFactory = void 0;
const Factory = require("factory.ts");
exports.batchAffiliationErrorMessageFactory = Factory.Sync.makeFactory({
    line_number: Factory.each(i => i + 1),
    message: "test error message"
});
